import { formatLetterDate, renderLetterTokens } from './letterTokens.js';
const HEADER = '{{ownership.name}}\n{{letter.date}}';
const SUBJECT_LINE = 'Re: {{letter.subject}}';
const MESSAGE = '{{message.body}}';
export function composeDistributionLetter(facts) {
    const values = {
        'ownership.name': facts.ownershipName,
        'letter.date': formatLetterDate(facts.letterDate),
        'letter.subject': facts.subject,
        'message.body': facts.message.trim(),
    };
    const attachments = facts.attachmentNames.length === 0
        ? ''
        : ['Attached:', ...facts.attachmentNames.map((name) => `- ${name}`)].join('\n');
    const sections = [
        { template: HEADER },
        { template: SUBJECT_LINE },
        { template: MESSAGE },
        facts.signature.trim(),
        attachments,
    ];
    const texts = [];
    for (const section of sections) {
        if (typeof section === 'string') {
            if (section !== '')
                texts.push(section);
            continue;
        }
        const rendered = renderLetterTokens(section.template, values);
        if (!rendered.ok)
            return rendered;
        texts.push(rendered.text);
    }
    return { ok: true, text: texts.join('\n\n') };
}
export function letterRefusalMessage(result) {
    switch (result.refusal.kind) {
        case 'missing_value':
            return `The email cannot be written: {{${result.refusal.token}}} has no value.`;
        case 'leftover_placeholder':
            return 'The email cannot be written: it still holds a placeholder.';
        default: {
            const _exhaustive = result.refusal;
            throw new Error(`Unhandled letter refusal: ${JSON.stringify(_exhaustive)}`);
        }
    }
}
//# sourceMappingURL=distributionLetter.js.map